export default {
  // 验证该用户(乐刻)是否可以领取
  getMemberBenefitsVerify(params) {
    return this.http('Columbus', 'get', '/api/v1/leke/member_benefits/verify', params);
  },
  // 领取乐刻会员权益
  getMemberBenefits(params) {
    return this.http('Columbus', 'post', '/api/v1/leke/member_benefits', params);
  },
  // 发送短信验证码
  getMobileVerifyCode(params) {
    return this.http('Columbus', 'post', '/api/v1/sms/send_code', params);
  },
  // 获取乐刻用户信息
  getLekeUserDetail(params) {
    return this.http('Columbus', 'get', '/api/v1/leke/users/detail', params);
  }
};
